var FormFieldBuilderErrors = {

  renderErrors: function (errors) {
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  },

  renderGeneralErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  renderRatingScaleErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  generalErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.field && errors.field.length) {
      for (var i = 0, ilen = errors.field.length; i < ilen; i++) {
        err.push(I18n.t('field') + ' ' + errors.field[i]);

      }
    }
    if (errors.field_type && errors.field_type.length) {
      for (var i = 0, ilen = errors.field_type.length; i < ilen; i++) {
        err.push(I18n.t('type') + ' ' + errors.field_type[i]);

      }
    }
    return err;
  },

  ratingScaleErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.label && errors.label.length) {
      for (var i = 0, ilen = errors.label.length; i < ilen; i++) {
        err.push(I18n.t('label') + ' ' + errors.label[i]);

      }
    }
    if (errors.range && errors.range.length) {
      for (var i = 0, ilen = errors.range.length; i < ilen; i++) {
        err.push(I18n.t('range') + ' ' + errors.range[i]);

      }
    }
    return err;
  },



};

export default FormFieldBuilderErrors